import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`

export const CarrierContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
`

export const CarrierLogoAndNameContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  align-items: center;
`

export const CarrierLogo = styled.img`
  height: 24px;
`
